import { useEffect } from "react";
import type { VideoConfig } from "./types";

interface SettingsMenuProps {
  videos: VideoConfig[];
  isOpen: boolean;
  onClose: () => void;
  onToggleVisibility: (videoId: string, visible: boolean) => void;
}

export function SettingsMenu({
  videos,
  isOpen,
  onClose,
  onToggleVisibility,
}: SettingsMenuProps) {
  useEffect(() => {
    // Load saved visibility settings
    try {
      const saved = localStorage.getItem("hamburgtv-visibility");
      if (saved) {
        const visibilityMap: Record<string, boolean> = JSON.parse(saved);
        videos.forEach((video) => {
          if (video.id in visibilityMap) {
            onToggleVisibility(video.id, visibilityMap[video.id] ?? false);
          }
        });
      }
    } catch (error) {
      console.error("Error loading visibility settings:", error);
    }
  }, []);

  return (
    <div
      id="settings-menu"
      className={`settings-menu ${isOpen ? "open" : ""}`}
    >
      <div className="settings-header">
        <h2>Settings</h2>
        <button
          id="close-settings"
          className="close-btn"
          onClick={onClose}
          aria-label="Close settings"
        >
          ×
        </button>
      </div>
      <div id="settings-content" className="settings-content">
        {videos.map((video) => (
          <div key={video.id} className="video-toggle">
            <label htmlFor={`toggle-${video.id}`}>{video.title}</label>
            <input
              type="checkbox"
              id={`toggle-${video.id}`}
              checked={video.visible}
              onChange={(e) => onToggleVisibility(video.id, e.target.checked)}
            />
          </div>
        ))}
      </div>
    </div>
  );
}

